import { ignoreDidNotGiveBirthRoutes, ignoreForMaleRoutes, routesMap } from "@/constants/routes";
import type useCurrentStep from "@/hooks/use-current-step";
import { UseMeResponse } from "@/hooks/use-me-query";
import selectIsGaveBirth from "./select-is-gave-birth";
import selectIsMale from "./select-is-male";
import selectWizardStep from "./select-wizard-step";

const shouldNavigateToWizard = (response: UseMeResponse, canSkip: boolean, currentStep?: ReturnType<typeof useCurrentStep>) => {
  const isMale = selectIsMale(response);
  const isGaveBirth = selectIsGaveBirth(response);
  const wizardStep = selectWizardStep(response);
  const wizardStepData = [...routesMap].find(
    ([, item]) => item.index === (wizardStep ?? 0),
  );
  const [key, item] = wizardStepData || [];
  const nextWizardStep =
    !wizardStep && wizardStep !== 0
      ? key?.toString()
      : item?.nextKey?.toString();

  if (
    !canSkip &&
    nextWizardStep &&
    !(isMale && ignoreForMaleRoutes.has(nextWizardStep)) &&
    !(!isGaveBirth && ignoreDidNotGiveBirthRoutes.has(nextWizardStep))
  ) {
    if (currentStep?.path.toString() !== nextWizardStep) {
      return nextWizardStep;
    }

    return false;
  }

  if (currentStep) {
    return "/";
  }

  return false;
};

export default shouldNavigateToWizard;
